import axios from 'axios'

import { parseError } from '../../../helpers'

const INITIAL_STATE = {
  error: false,
  isLoaded: false,
  items: [],
}

const FETCH_BRANCHES = 'FETCH_BRANCHES'
const POPULATE_BRANCHES = 'POPULATE_BRANCHES'
const SET_BRANCHES_ERROR = 'SET_BRANCHES_ERROR'

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BRANCHES:
      return {
        ...state,
        items: [],
        isLoaded: false,
      }
    case POPULATE_BRANCHES:
      return {
        ...state,
        items: action.payload,
        isLoaded: true,
      }
    case SET_BRANCHES_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoaded: true,
      }
    default:
      return state
  }
}

export const fetchBranchesAction = () => async dispatch => {
  try {
    dispatch({ type: SET_BRANCHES_ERROR, payload: false })
    dispatch({ type: FETCH_BRANCHES })
    const response = await axios.get('/getBranches')
    // console.log(response.data)
    dispatch({ type: POPULATE_BRANCHES, payload: response.data })
  } catch (e) {
    dispatch({
      type: SET_BRANCHES_ERROR,
      payload: parseError(`fetchBranchesAction - ${parseError(e)}`),
    })
  }
}

export default reducer
